/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';

// grid
const selectGridColumnState  = ({devices: {grid}}) => grid?.columnState;

export const devicesGridColumnStateSelector = createDeepEqualSelector(
  selectGridColumnState, columnState => columnState
);

//device password
const selectDevicePassword                  = ({devices: {devicePassword}}) => devicePassword;
const selectDevicePasswordShowImportDialog  = state => selectDevicePassword(state).showImportDialog;
const selectDevicePasswordShowGridtDialog   = state => selectDevicePassword(state).isEditing;
const selectDevicePasswordSelectedDevices   = state => selectDevicePassword(state).selectedIdentifiers;
const selectDevicePasswordIdentifierType    = state => selectDevicePassword(state).identifierType;

//bulk edit group
const selectBulkEditGroup            = ({devices: {bulkEditGroup}}) => bulkEditGroup;
const selectBulkEditGroupShowDialog  = state => selectBulkEditGroup(state).isEditing;
const selectBulkEditGroupSelected    = state => selectBulkEditGroup(state).selected;
const selectBulkEditGroupShowLoading = state => selectBulkEditGroup(state).loading;
const selectBulkEditGroupResult      = state => selectBulkEditGroup(state).result;

//manage services
const selectManageServices           = ({devices: {manageServices}}) => manageServices;
const selectManageServicesShowDialog = state => selectManageServices(state).isEditing;
const selectManageServicesSelected   = state => selectManageServices(state).selected;

//view
const selectView           = ({devices: {view}}) => view;
const selectViewShowDialog = state => selectView(state).isEditing;

// audit
const selectAudit                  = ({devices: {audit}}) => audit;
const selectAuditShowDialog        = state => selectAudit(state).isEditing;
const selectAuditSelected          = state => selectAudit(state).selected;
const selectAuditRecord            = state => selectAudit(state).auditRecord;
const selectAuditShowChangesDialog = state => selectAudit(state).showChangesDialog;

// swap
const selectSwap                  = ({devices: {swap}}) => swap;
const selectSwapShowDialog        = state => selectSwap(state).isEditing;
const selectSwapSelected          = state => selectSwap(state).selected;
const selectSwapShowConfirmDialog = state => selectSwap(state).showConfirmDialog;
const selectSwapResult            = state => selectSwap(state).result;

export const devicePasswordShowImportDialogSelector = createSelector(
  selectDevicePasswordShowImportDialog, (showImportDialog: boolean) => showImportDialog
);
export const devicePasswordShowGridDialogSelector = createSelector(
  selectDevicePasswordShowGridtDialog, (isEditing: boolean) => isEditing
);
export const devicePasswordSelectedDevicesSelector = createDeepEqualSelector(
  selectDevicePasswordSelectedDevices, selectedIdentifiers => selectedIdentifiers
);
export const devicePasswordIdentifierTypeSelector = createSelector(
  selectDevicePasswordIdentifierType, (identifierType: string) => identifierType
);

export const bulkEditGroupShowDialogSelector = createSelector(
  selectBulkEditGroupShowDialog, (isEditing: boolean) => isEditing
);
export const bulkEditGroupSelectedDevicesSelector = createDeepEqualSelector(
  selectBulkEditGroupSelected, selected => selected
);
export const bulkEditGroupShowLoadingSelector = createSelector(
  selectBulkEditGroupShowLoading, (loading: boolean) => loading
);
export const bulkEditGroupResultSelector = createDeepEqualSelector(
  selectBulkEditGroupResult, result => result
);

export const manageServicesShowDialogSelector = createSelector(
  selectManageServicesShowDialog, (isEditing: boolean) => isEditing
);
export const manageServicesSelectedDevicesSelector = createDeepEqualSelector(
  selectManageServicesSelected, selected => selected
);

export const viewShowDialogSelector = createSelector(
  selectViewShowDialog, (isEditing: boolean) => isEditing
);

// modular search
const selectModularSearch = ({devices: {search}}) => search;

export const devicesModularSearchSelector = createDeepEqualSelector(
  selectModularSearch, search => search
);

export const deviceAuditShowDialogSelector = createSelector(selectAuditShowDialog,
  (isEditing: boolean) => isEditing
);
export const deviceAuditSelectedSelector = createDeepEqualSelector(selectAuditSelected,
  selected => selected
);
export const deviceAuditRecordSelector = createDeepEqualSelector(selectAuditRecord,
  auditRecord => auditRecord
);
export const deviceAuditShowChangesDialogSelector = createSelector(selectAuditShowChangesDialog,
  (showChangesDialog: boolean) => showChangesDialog
);

export const deviceSwapShowDialogSelector = createSelector(selectSwapShowDialog,
  (isEditing: boolean) => isEditing
);
export const deviceSwapSelectedSelector = createDeepEqualSelector(selectSwapSelected,
  selected => selected
);
export const deviceSwapShowConfirmDialogSelector = createSelector(selectSwapShowConfirmDialog,
  (showConfirmDialog: boolean) => showConfirmDialog
);
export const deviceSwapResultSelector = createDeepEqualSelector(selectSwapResult,
  result => result
);

const selectHeartBeat     = ({devices: {devices}}) => devices;
const selectHeartBeatData = state => selectHeartBeat(state).item;

export const createHeartBeatSelector = createDeepEqualSelector(
  selectHeartBeatData, item => item
);

//pending jobs
const selectJob                   = ({devices: {pendingJobs}}) => pendingJobs;
const selectPendingJobShowDialog  = ({devices: {showPendingJobs}}) => showPendingJobs;

export const showPendingJobsSelector = createSelector(
  selectPendingJobShowDialog, (showPendingJobs: boolean) => showPendingJobs
);
export const downloadJobsPendingJobsSelector = createDeepEqualSelector(
  selectJob, (pendingJobs) => pendingJobs
);
